export const AUTH_ENDPOINTS = {
  LOGIN: `/WebUserAdmin/EvaluateLogin`,
  MFA_SETUP: `/Auth/SetupMFA`,
  MFA_VERIFY: `/Auth/LoginWithTotp`,
  MFA_RESET: `/TOTP/ResetAuthKey`,
  FORGOT_PASSWORD: `/Auth/ForgotPassword`,
  RESOLVE_FORGOT_PASSWORD_LINK: `/Auth/ResolveForgotPasswordLink`,
  GET_USER_ADMIN: "/WebUserAdmin/GetUserAdmin",
  GET_DISCLAIMER: `/WebUserAdmin/GetDisclaimer`,
  ACCEPT_DISCLAIMER: `/WebUserAdmin/InsertOrUpdateDisclaimer`,
  UPDATE_RESET_PASSWORD: "/WebUser/UpdateResetPassword",
  GET_CHALLENGE_PHRASES:"/Auth/GetChallengePhrases",
  VALIDATE_SECURITY_ANSWER: "/Auth/ValidateSecurityAnswer"
};

export const HOME_ENDPOINTS = {
  HOME_LINKS: `/Home/HomeMainLinks`,
}

export const ASSET_ENDPOINTS = {
  GET_INVESTORS_BY_CONTACT: "/WebAssets/GetInvestorByContact",
  GET_ENTITIES_BY_INVESTOR: "/WebAssets/GetEntityByInvestor",
  GET_REPORT_DATES: "/WebAssets/GetReportDatesForAccountOrContact",
  GET_ASSET_SUMMARY_AND_ALLOCATION: "/WebAssets/GetAssetSummaryAndAllocationDetails",

    // Asset Details
  GET_REPORT_DATES_FOR_ACCOUNT_OR_CONTACT: "/WebAssets/GetReportDatesForAccountOrContact",
  GET_ASSET_STRATEGY_LIST: "/WebAssets/GetAssetStrategyList",
  GET_ASSET_PERFORMANCE_DETAILS: "/WebAssets/GetAssetPerformanceDetails",

  
  //Asset Statements
GET_INVESTORS_BY_CONTACT_STATEMENTS: "/WebAssets/GetInvestorByContact",
GET_ENTITIES_BY_INVESTOR_STATEMENTS: "/WebDocument/GetEntitiesByInvestor",
GET_STATEMENTS_BY_ENTITY: "/WebStatements/GetDocumentsByEntity",

GET_CLIENT_DOCUMENT_DOWNLOAD: "/WebStatements/GetClientDocumentDownload",
GET_CLIENT_DOCUMENTS_DOWNLOAD: "/WebStatements/GetClientDocumentsDownload",
GET_CLIENT_DOCUMENTS_SINGLE_PDF_DOWNLOAD: "/WebStatements/GetClientDocumentsSinglePDFDownload",
GET_DOCUMENTS_AS_ZIP_DOWNLOAD: "/WebDocument/GetDocumentAsSingleZipDownload",

GET_STATEMENT_CUSTOMIZE: "/WebStatements/GetStatementCustomize",
SAVE_STATEMENT_CUSTOMIZE: "/WebStatements/SaveStatementCustomize"

};

export const DOCUMENT_ENDPOINTS = {
  GET_INVESTORS_BY_CONTACT: "/WebAssets/GetInvestorByContact",
  GET_ENTITIES_BY_INVESTOR: "/WebDocument/GetEntitiesByInvestor",
  GET_CATEGORY_BY_ENTITY: "/WebDocument/GetCategoryByEntity",
  GET_DOCUMENTS_BY_ENTITY: "/WebDocument/GetDocumentsByEntity",
  GET_CLIENT_DOCUMENT_DOWNLOAD: "/Statement/GetClientDocumentDownload",
  GET_CLIENT_DOCUMENTS_DOWNLOAD: "/Statement/GetClientDocumentsDownload",
  GET_CLIENT_DOCUMENTS_SINGLE_PDF_DOWNLOAD: "/Statement/GetClientDocumentsSinglePDFDownload",
  GET_DOCUMENT_AS_SINGLE_ZIP_DOWNLOAD: "/Documents/GetDocumentAsSingleZipDownload",
  GET_DOCUMENTS_CUSTOMIZE:"/WebDocument/GetDocumentsCustomize",
  UPDATE_GRID_CUSTOMIZE:"/WebStatement/GridCustomizeColumns_Update",
  GET_DOCUMENT_BY_DOCUMENT_ID:"/WebDocument/GetDocumentByDocumentId",
  GET_DOCUMENT_BLOB_BY_DOCUMENT_ID:"/WebDocument/GetDocumentBlobByDocumentId",
  GET_DOCUMENT_NAME_BY_DOCUMENT_ID:"/WebDocument/GetDocumentNameByDocumentId",
  GET_WEB_DOCUMENT_AS_SINGLE_ZIP:"/WebDocument/GetDocumentAsSingleZipDownload"
};

// src/services/researchEndpoints.js
export const ASSET_RESEARCH_ENDPOINTS = {
  GET_INVESTOR_BY_CONTACT: "/WebAssets/GetInvestorByContact",
  GET_RESEARCH_ENTITIES_BY_INVESTOR: "/WebDocument/GetResearchEntitiesByInvestor",
  GET_RESEARCH_CATEGORIES_BY_ENTITY: "/WebDocument/GetResearchCategoryByEntity",
  GET_RESEARCH_DOCUMENTS_BY_ENTITY: "/WebDocument/GetResearchDocumentsByEntity",
  GET_RESEARCH_DOCUMENT_BY_ID: "/WebDocument/GetResearchDocumentByDocumentId",
  GET_RESEARCH_DOCUMENT_NAME_BY_ID: "/WebDocument/GetResearchDocumentNameByDocumentId",
  GET_DOCUMENTS_CUSTOMIZE: "/WebDocument/GetDocumentsCustomize",
  SAVE_GRID_CUSTOMIZE_COLUMNS: "/WebStatement/GridCustomizeColumns_Update",
  GET_RESEARCH_ZIP_DOWNLOAD: "/WebDocument/GetResearchDocumentAsSingleZipDownload",
  GET_ENTITIES_BY_INVESTOR_FOR_STATEMENT: "/WebDocument/GetEntitiesByInvestor",
  // MVC endpoints
  GET_CLIENT_RESEARCH_DOCUMENTS_DOWNLOAD:
    "/ResearchDocuments/GetClientResearchDocumentsDownload",
  GET_CLIENT_RESEARCH_DOCUMENTS_SINGLE_PDF_DOWNLOAD:
    "/ResearchDocuments/GetClientResearchDocumentsSinglePDFDownload",
  GET_RESEARCH_DOCUMENTS_ZIP_DOWNLOAD:
    "/ResearchDocuments/GetResearchDocumentAsSingleZipDownload",
};


export const ADMIN_CONTACT_ENDPOINTS = {
  GET_CONTACT_SUMMARY: "/WebAdminContact/GetContactsSummary",
  GET_CONTACT_CUSTOMIZE :"/WebAdminContact/GetContactCustomize",
  SAVE_CONTACT_CUSTOMIZE :"/WebAdminContact/SaveContactCustomize",
  GET_CONTACTS: "/WebAdminContact/WebAdminGetUsers",
  GET_CONTACT_MENU_PERMISSIONS: "/WebAdminContact/GetContactMenuPermissions",
  GET_EMAIL_HISTORY_BY_CONTACT: "/WebEmail/GetEmailHistoryByContact",
  UPDATE_SUBSCRIPTIONS: "/WebUserAdmin/UpdateSubscriptions",
  CONTACT_RESET_MFA: "/WebUserAdmin/UpdateAuthKey"

}

export const ADMIN_PANEL_ENDPOINTS = {
  GET_ADMIN_USERS: "/WebUserAdmin/GetUserAdmin",
  INSERT_ADMIN_USER: "/WebUserAdmin/InsertUserAdmin",
  UPDATE_ADMIN_USER: "/WebUserAdmin/UpdateUserAdmin",
  DELETE_USER:"/WebUserAdmin/DeleteUserAdmin",
  RESET_USER_MFA: "/WebUserAdmin/ResetMFA",
  GET_SECURITY_QUESTIONS: "/WebUserAdmin/GetChallengePhrases",
  GET_SECURITY_ANSWERS: "/WebUserAdmin/GetChallengePhrasesAnswer",
  INSERT_OR_UPDATE_SECURITY_QUESTION:"/WebUserAdmin/InsertOrUpdateChallengePhrases",
  INSERT_OR_UPDATE_SECURITY_ANSWER:"/WebUserAdmin/InsertOrUpdateChallengePhrasesAnswer",
  GET_UNLOCKED_USERS:"/WebUserAdmin/GetUnlockedUsers",
  UPDATE_LOGIN_ATTEMPTS:"/WebUserAdmin/UpdateLoginAttempts",
  GET_LOCKED_USERS:"/WebUserAdmin/GetLockedUsers",
  GET_SYSTEM_SETTINGS:"/WebUserAdmin/GetSystemSettings",
  UPDATE_SYSTEM_SETTINGS:"/WebUserAdmin/UpdateSystemSettings",
  GET_USER_LOGIN_ATTEMPTS:"/Report/GetFailedLoginAttempts",
  GET_USER_LOGINS_BY_IP_DETAILS:"/Report/GetUserLoginByIPDetail",
  GET_USER_LOGINS_BY_IP_SUMMARY:"/Report/GetUserLoginByIPSummary",
  GET_USER_PASSWORD_RESET_ACTIVITIES:"/Report/GetPasswordResetActivity",
  GET_USER_ACTIVE_SESSIONS:"/Report/GetActiveSessions",
  GET_ACTIVE_USERS:"/Report/GetActiveUsers",
  GET_PAGE_TRACKING_DETAILS:"/WebActivity/GetPageTrackingDetails",
  GET_CONTACT_USER_INFO:"/WebAdminContact/WebAdminGetUserInfo"
}

export const IP_SETTINGS_ENDPOINTS ={
  GET_IP_SETTINGS:"/WebIpSettings/GetIPSettings",
  INSERT_OR_UPDATE_IP_SETTINGS:"/WebIpSettings/InsertOrUpdateIpSettings",
  DELETE_IP_SETTINGS:"/WebIpSettings/DeleteIPSettingsById"
}

export const ADMIN_DOCUMENTS_ENDPOINTS = {
  GET_DOCUMENT_SUMMARY: "/WebAdminDocument/GetDocumentSummary",
  GET_ADMIN_DOCUMENT_TYPES: "/WebAdminDocument/GetAdminDocumentType",
  GET_DOCUMENT_FAMILIES: "/WebAdminDocument/GetDocumentFamily",
  GET_ENTITY_BY_FAMILY_ID: "/WebAdminDocument/GetEntityByFamily",
  GET_DOCUMENT_BY_WEBSTATUS: "/WebAdminDocument/GetDocumentByWebStatus",
  GET_DOCUMENT_RECIPIENTS: "/WebDocument/GetRecipientsForDocList",
  UPDATE_DOCUMENT_STATUS: "/WebAdminDocument/UpdateDocumentStatus",
  INSERT_QUEUED_EMAILS: "/WebEmail/InsertQueuedEmail",
  INSERT_DRAFT_EMAIL: "/WebEmail/InsertDraftEmail",
  GET_EMAIL_TEMPLATES: "/WebEmail/GetEmailTemplateList",
  GET_USER_CUSTOM_SETTINGS: "/WebAdminDocument/GetUserCustomSettings",
  UPDATE_CUSTOM_SETTINGS: "/WebAdminDocument/UpdateCustomSettings"
}

export const ASSET_STATEMENT_ENDPOINTS = {
  GET_INVESTOR_BY_CONTACT: "/WebAssets/GetInvestorByContact",
  GET_ENTITIES_BY_INVESTOR: "/WebDocument/GetEntitiesByInvestor",
  GET_DOCUMENTS_BY_ENTITY: "/WebDocument/GetDocumentsByEntity",
  GET_DOCUMENT_BY_DOCUMENT_ID: "/WebDocument/GetDocumentByDocumentId",
  GET_DOCUMENT_NAME_BY_DOCUMENT_ID: "/WebDocument/GetDocumentNameByDocumentId",
  GET_STATEMENT_CUSTOMIZE: "/WebStatement/GetStatementCustomize",
  SAVE_GRID_CUSTOMIZE_COLUMNS: "/WebStatement/GridCustomizeColumns_Update",
  GET_STATEMENT_ENTITY_BY_INVESTOR: "/WebStatement/GetStatementEntityByInvestor",
  GET_STATEMENT_AS_SINGLE_ZIP_DOWNLOAD: "/WebStatement/GetStatementAsSingleZipDownload",
  // MVC download endpoints
  GET_CLIENT_DOCUMENT_DOWNLOAD: "/Statement/GetClientDocumentDownload",
  GET_CLIENT_DOCUMENTS_DOWNLOAD: "/Statement/GetClientDocumentsDownload",
  GET_CLIENT_DOCUMENTS_SINGLE_PDF_DOWNLOAD:
    "/Statement/GetClientDocumentsSinglePDFDownload",
};

export const PORTFOLIOATTRIBUTION_ENDPOINTS = {
  GET_PORTFOLIO_BY_CLIENT_STATEMENT: `/PortfolioAttribution/GetPortfolioByClientStatement`,
  GET_PORTFOLIO_GROUP_TREE_DATA: `/PortfolioAttribution/GetTreeOfFamilyClientStatements`,
  GET_PORTFOLIO_ATTRIBUTION_UI_DATA: `/PortfolioAttribution/GetPortfolioAttributionUIData`,
  GET_VIEWS: `/PortfolioAttribution/GetPortfolioAttributionViews`,
  GET_REPORT_CLASSIFICATIONS: `/PortfolioAttribution/GetReportClassifications`,
  GET_PORTFOLIO_DOCUMENT_MAPPING: `/PortfolioAttribution/GetPortfolioDocumentMapping`,
  GET_PORTFOLIO_DOCUMENT_BYID: `/PortfolioAttribution/GetDocumentByDocumentId`,
  EXPORT_TIME_SERIES: `/PortfolioAttribution/ExportTimeSeries`,
};


export const ADMIN_EMAIL_ENDPOINTS = {
  GET_EMAIL_BY_STATUS: "/WebEmail/GetEmailsByStatus",
  UPDATE_EMAIL_STATUS: "/WebEmail/UpdateEmailStatus",
  DELETE_EMAIL: "/WebEmail/DeleteEmail",
  GET_DRAFT_EMAIL: "/WebEmail/GetDraftEmail",
  UPDATE_DRAFT_EMAIL: "/WebEmail/UpdateDraftEmail",

  GET_EMAIL_TEMPLATE_LIST: "/WebEmail/GetEmailTemplateList",
  GET_EMAIL_TEMPLATE_TYPES: "/WebEmail/GetEmailTemplateTypes",
  GET_EMAIL_TEMPLATE_FIELDS: "/WebEmail/GetEmailTemplateFields",
  GET_TEMPLATE_ATTACHMENTS: "/WebEmail/GetTemplateAttachments",

  
  PREVIEW_DRAFT_EMAIL: "/WebEmail/PreviewDraftEmail",
  GET_EMAIL_INFO: "/WebEmail/GetEmailInfo",
  
  INSERT_OR_UPDATE_EMAIL_TEMPLATE: "/WebEmail/InsertOrUpdateEmailTemplate",
    INSERT_TEMPLATE_ATTACHMENTS: "/WebEmail/InsertTemplateAttachments",
    UPDATE_DEFAULT_TEMPLATE: "/WebEmail/UpdateDefaultTemplate",
    COPY_AND_SAVE_EMAIL_TEMPLATE: "/WebEmail/CopyAndSaveEmailTemplate",
    DELETE_EMAIL_TEMPLATE: "/WebEmail/DeleteEmailTemplate",
    GET_EMAIL_ATTACHMENT_CONTENT_INFO: "/WebEmail/GetEmailAttachmentContentInfo",
    TEST_SEND_EMAIL_TEMPLATE: "/WebEmail/TestSendEmailTemplate",
    SEND_INITIAL_ACCESS_MAIL: "/WebUser/InitialAccessSendMail",
  };

export const USER_PROFILE_ENDPOINTS = {
  UPDATE_RESET_PASSWORD: "/WebUser/UpdateResetPassword",
  GET_CHALLENGE_PHRASES: "/WebUserAdmin/GetChallengePhrases",
  GET_CHALLENGE_PHRASES_ANSWER: "/WebUserAdmin/GetChallengePhrasesAnswer",
  INSERT_OR_UPDATE_CHALLENGE_PHRASES_ANSWER:"/WebUserAdmin/InsertOrUpdateChallengePhrasesAnswer",
  GET_USER_INFO: "/WebAdminContact/WebAdminGetUserInfo",
  GET_USER_ADMIN: "/WebUserAdmin/GetUserAdmin",
  UPDATE_NOTIFICATION_PREFERENCES:"/WebUserAdmin/UpdateNotificationPreferences",
  RESET_MFA: "/WebUserAdmin/ResetMFA",
  VERIFY_MFA_CODE: "/UserProfile/Verify",
};